/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react"
import { StyledAmount } from "./style"
import { TitleProps } from "./interfaces"

const Title = ({
  children,
  size,
  color,
  fontWeight,
  textTransform,
  marginTop,
  marginBottom,
  justify,
  align,
  lineHeight,
  marginRight,
}: TitleProps) => {
  return (
    <StyledAmount
      size={size}
      color={color}
      fontWeight={fontWeight}
      textTransform={textTransform}
      marginTop={marginTop}
      marginBottom={marginBottom}
      justify={justify}
      align={align}
      lineHeight={lineHeight}
      marginRight={marginRight}
    >
      {children}
    </StyledAmount>
  )
}

export default Title
